module.exports = __webpack_public_path__ + "media/video-home.bc49adb1.mp4";